import { TransactionCategory } from '@shipstation/financial-services-ui-components';
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Edit Payment Method',
    description: 'Header text for the edit payment method modal',
    id: 'YY2HkV',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    description: 'Text for the cancel button in the manage payment method flow',
    id: 'FW8sIS',
  },
  saveButton: {
    defaultMessage: 'Save',
    description: 'Text for the save button in the manage payment method flow',
    id: 'qzQG1q',
  },
  editSuccess: {
    defaultMessage: 'Payment method edited successfully.',
    description: 'Success message after editing a payment method',
    id: 'umYg/7',
  },
  editError: {
    defaultMessage: 'There was an error editing the payment method. Please try again later.',
    description: 'Error message when editing a payment method fails',
    id: 'ljn12n',
  },
});

export const assignedPreferencesMessages = defineMessages({
  [TransactionCategory.AddFunds]: {
    description: 'Assigned preference for Shipstation Balance',
    defaultMessage: 'ShipStation Balance',
    id: 'iHzUVy',
  },
  [TransactionCategory.Subscription]: {
    description: 'Assigned preference for Subscription',
    defaultMessage: 'Subscription',
    id: 'vQPlsl',
  },
  [TransactionCategory.Store]: {
    description: 'Assigned preference for Store',
    defaultMessage: 'Store',
    id: 'kf0KWT',
  },
});
